// #region Imports
import { defineComponent, nextTick } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Class
    name: 'g-cart-page',
    // #endregion
    // #region Properties
    data: () => ({
        cart: {},
        oci: null,
        schema: {},
        data: {},
        user: {},
        messages: [],
        mode: "",
        errorMessage: "",
        hasConditionError: false,
        isLoading: false,
        isLoaded: false,
        isWorking: false
    }),
    // #endregion
    // #region Boostrap
    created() {
        //Mode
        this.mode = this.$route.params?.mode;
        //Load
        this.loadData();
    },
    beforeMount() {
        this.$host.eventBus.on('refresh', this.loadData);
    },
    beforeUnmount() {
        this.$host.eventBus.off('refresh', this.loadData);
    },
    // #endregion
    // #region Computed
    computed: {
        isEmpty() {
            if (this.mode !== 'cart' && this.mode) {
                return false;
            }
            if (utils.isNullOrEmpty(this.cartID)) {
                return true;
            }
            if (!this.cart) {
                return true;
            }
            if (utils.isNullOrEmpty(this.cart?.cartID)) {
                return true;
            }
            if (!this.cart.lines || this.cart.lines.length == 0) {
                return true;
            }
            return false;
        },
        cartID() {
            return this.$route.params.cartID;
        },
    },
    // #endregion
    // #region Watch
    watch: {
        '$route.params.mode': function (value) {
            let tMode = value;
            if (tMode && this.mode !== tMode) {
                this.mode = tMode;
                this.loadData();
            }
            else {
                this.mode = 'cart';
                this.loadData();
            }
        },
        '$route.params.cartID': function (value) {
            //Vars
            this.mode = 'cart';
            this.hasConditionError = false;
            //Load
            this.loadData();
        },
        '$data.data.shipping.mode': function (value) {
            if (this.isLoading || !this.isLoaded) {
                return;
            }
            this.saveData('update');
        },
        '$data.data.shipping.avis': function (value) {
            if (this.isLoading || !this.isLoaded) {
                return;
            }
            this.saveData('update');
        },
        '$data.data.shipping.option_avis': function (value) {
            if (this.isLoading || !this.isLoaded) {
                return;
            }
            this.saveData('update');
        },
        '$data.data.shipping.option_express': function (value) {
            if (this.isLoading || !this.isLoaded) {
                return;
            }
            this.saveData('update');
        },
        '$data.data.shipping.option_laufzeit': function (value) {
            if (this.isLoading || !this.isLoaded) {
                return;
            }
            this.saveData('update');
        },
        '$data.data.addresses.delivery.mode': function (value) {
            if (this.isLoading || !this.isLoaded) {
                return;
            }
            if (value === 'address') {
                return;
            }
            this.saveData('update');
        },
        '$data.data.addresses.delivery.addressID': function (value) {
            if (this.isLoading || !this.isLoaded) {
                return;
            }
            this.saveData('update--delivery_addressid');
        },
        '$data.data.addresses.delivery.zipCode': function (value) {
            if (this.isLoading || !this.isLoaded) {
                return;
            }
            this.saveData('update');
        },
        '$data.data.conditionsconfirmed': function (value) {
            this.hasConditionError = false;
        },
    },
    // #endregion
    // #region Core
    methods: {
        // #region CRUD (Cart)
        async loadData() {
            // #region Check
            if (utils.isNullOrEmpty(this.cartID)) {
                return;
            }
            // #endregion
            // #region Reset
            if (this.data?.conditionsconfirmed) {
                this.data.conditionsconfirmed = false;
            }
            // #endregion
            // #region Run
            //Loading
            this.isLoading = true;
            host.api.get(`commerce/checkout/${this.cartID}?mode=${this.mode}`)
                .then(e => {
                if (e.data?.$dataMode) {
                    this.mode = e.data?.$dataMode;
                }
                if (e.data?.cart) {
                    this.cart = e.data.cart;
                }
                if (e.data?.data) {
                    this.data = e.data.data;
                }
                if (e.data?.schema) {
                    this.schema = e.data.schema;
                }
                if (e.data?.messages) {
                    this.messages = e.data.messages;
                }
                if (e.data?.breadcrumbs) {
                    this.$store.commit('navigation/setBreadcrumb', e.data.breadcrumbs);
                }
                if (e.data?.$dataMode === 'thankyou') {
                    this.$store.commit('carts/load');
                }
                if (this.schema?.options?.text_Cart) {
                    this.$host.pageMeta.title = this.schema?.options?.text_Cart + " " + this.cart?.cartNumber;
                }
                nextTick(() => {
                    this.isLoading = false;
                    this.isLoaded = true;
                });
            })
                .catch(e => {
                host.notification.showToast(utils.getAxiosErrorMessage(e), "error");
                this.isLoading = false;
            });
            // #endregion
        },
        async loadAfterLogin() {
            try {
                // #region Run
                await host.api.post(`commerce/carts/${this.cartID}/activate`);
                // #endregion
                // #region Store
                this.$store.commit('carts/load');
                // #endregion                        
                // #region Load
                this.loadData();
                // #endregion
            }
            catch (e) {
                host.notification.showError(e);
            }
        },
        async saveData(operationName, onSaved = undefined) {
            // #region Meter
            this.isLoading = true;
            // #endregion
            // #region Save
            //Url
            let tUrl = this.mode === 'summary' ? `commerce/checkout/${this.cart.cartID}/finish?operation=${operationName}` : `commerce/checkout/${this.cart.cartID}?mode=${this.mode}&operation=${operationName}`;
            try {
                // #region Path
                let e = await host.api.patch(tUrl, this.data);
                // #endregion
                // #region Payment
                if (e.data?.$nextMode === 'payment-confirm') {
                    //Run
                    this.runPayment(e.data.payment);
                    //Finish
                    this.isLoading = false;
                    this.isWorking = false;
                    return;
                }
                // #endregion
                // #region Internal
                if (e.data?.cart) {
                    this.cart = e.data.cart;
                }
                if (e.data?.data) {
                    this.data = e.data.data;
                }
                if (e.data?.schema) {
                    this.schema = e.data.schema;
                }
                if (e.data?.messages) {
                    this.messages = e.data.messages;
                }
                if (e.data?.user) {
                    this.user = e.data.user;
                }
                // #endregion
                // #region Store
                if (e.data?.breadcrumbs) {
                    this.$store.commit('navigation/setBreadcrumb', e.data.breadcrumbs);
                }
                if (e.data?.$nextMode === 'thankyou') {
                    this.$store.commit('carts/load');
                }
                else if (e.data?.cart) {
                    this.$store.commit('carts/setCart', e.data.cart);
                }
                // #endregion
                // #region Next
                if (onSaved) {
                    onSaved(e.data?.$nextMode);
                }
                // #endregion
                // #region Loading
                this.isLoading = false;
                // #endregion
            }
            // #endregion
            // #region Error
            catch (error) {
                // #region Data
                if (error.response?.data?.messages) {
                    this.messages = error.response?.data?.messages;
                }
                else {
                    host.notification.showToast(utils.getAxiosErrorMessage(error), "error");
                }
                // #endregion
                // #region Loading
                this.isLoading = false;
                this.isWorking = false;
                // #endregion
            }
            // #endregion
        },
        async runPayment(data) {
            // #region Simple (URL)
            if (data?.nextAction === 'redirect_to_url') {
                window.location.href = data.nextActionUrl;
            }
            // #endregion
            // #region Run
            else {
                // #region Gateway
                //Gateway
                let tGateway = this.$host.provider.get('PAYMENT', data.gateway.clientType);
                //Init
                await tGateway.initialize(data.gateway);
                //Handle
                let tResult = await tGateway.handle(data.nextAction, data);
                // #endregion
                // #region Result
                if (!tResult.isSucceeded) {
                    this.messages.push({
                        style: 'danger',
                        description: tResult.errorMessage,
                    });
                }
                else if (tResult.nextAction === 'confirm') {
                    this.saveData('payment-confirm', async (nextMode) => {
                        // #region Meter
                        this.isWorking = false;
                        // #endregion
                        // #region Rounting
                        this.$router.push({ params: { mode: nextMode ?? 'cart' } });
                        // #endregion
                    });
                }
                // #endregion
            }
            // #endregion
        },
        async runMoveNext(mode) {
            // #region Validate
            let tForm = this.$refs?.frmMain?.$form;
            if (tForm && !tForm.validate()) {
                return;
            }
            if (this.mode === 'summary' && this.schema?.options?.agb_Caption && !this.data.conditionsconfirmed) {
                this.hasConditionError = true;
                return;
            }
            // #endregion
            // #region Meter
            this.isWorking = true;
            // #endregion
            // #region Events
            let tArgs = {
                cancel: false,
                mode: this.mode,
                cart: this.cart,
                data: this.data
            };
            //Run
            await host.eventBus.emit('checkout-before-commit', tArgs);
            //Check
            if (tArgs.cancel) {
                this.isWorking = false;
                return;
            }
            // #endregion
            // #region Save
            this.saveData(mode, async (nextMode) => {
                // #region Speical
                if (nextMode === 'activate') {
                    await host.login.loginByUsername(this.data.profile.eMail, this.data.profile.password);
                }
                // #endregion
                // #region Meter
                this.isWorking = false;
                // #endregion
                // #region Rounting
                this.$router.push({ params: { mode: nextMode ?? 'cart' } });
                // #endregion
            });
            // #endregion
        },
        async runPunchOut() {
            try {
                // #region Meter
                this.isLoading = true;
                this.isWorking = true;
                // #endregion
                // #region Callback
                //Load
                let e = await host.api.patch(`commerce/checkout/${this.cart.cartID}/oci-punchout`);
                //Result
                if (!e.data) {
                    throw {
                        message: 'Kein OCI-Warenkorb erhalten'
                    };
                }
                this.oci = e.data;
                // #endregion
                // #region Send
                this.$nextTick(() => {
                    this.$refs.ociform.submit();
                });
                // #endregion
                //Loading
                this.isLoading = false;
                this.isWorking = false;
            }
            catch (e) {
                //Loading
                this.isLoading = false;
                this.isWorking = false;
                //Show
                host.notification.showError(e);
            }
        },
        // #endregion
        // #region CRUD (Line)
        deleteLine(event, line) {
            //event
            event.preventDefault();
            host.api.delete(`commerce/checkout/${this.cart.cartID}/lines/${line.lineID}`)
                .then(e => {
                // #region Internal
                if (e.data?.cart) {
                    this.cart = e.data.cart;
                }
                if (e.data?.schema) {
                    this.schema = e.data.schema;
                }
                // #endregion
                // #region Store
                if (e.data?.cart) {
                    this.$store.commit('carts/setCart', e.data.cart);
                }
                // #endregion
            })
                .catch(e => {
                host.notification.showToast(utils.getAxiosErrorMessage(e), "error");
            });
        },
        updateLine(event, line) {
            if (this.isLoading) {
                return;
            }
            this.isLoading = true;
            let tData = {
                quantity: line.quantity
            };
            //data
            host.api.patch(`commerce/checkout/${this.cart.cartID}/lines/${line.lineID}`, tData)
                .then(e => {
                // #region Internal
                if (e.data?.cart) {
                    this.cart = e.data.cart;
                }
                // #endregion
                // #region Store
                if (e.data?.cart) {
                    this.$store.commit('carts/setCart', e.data.cart);
                }
                // #endregion
                // #region Loading
                this.isLoading = false;
                // #endregion
            })
                .catch(e => {
                // #region Data
                host.notification.showToast(utils.getAxiosErrorMessage(e), "error");
                // #endregion
                // #region Loading
                this.isLoading = false;
                // #endregion
            });
        },
        // #endregion
        // #region Command
        async cmdRunCommand(name) {
            if (name === '$reject') {
                this.$router.push({ params: { mode: 'reject' } });
            }
            else if (name === 'oci-punchout') {
                await this.runPunchOut();
            }
            else {
                await this.runMoveNext(name);
            }
        },
        async cmdRunLineCommand(name, line) {
            if (name === 'files') {
                this.uploadDocuments(line);
            }
            else if (name === 'comment') {
                this.lineComment(line);
            }
        },
        lineComment(line) {
            //Run
            let tData = {
                cartName: this.cart.cartName,
                cartID: this.cart.cartID,
                lineID: line.lineID,
                line: line,
                comment: line.comment
            };
            host.notification.showModal(host.components.getComponent('g-cart-line-comment'), tData, { size: 'default' });
        },
        uploadDocuments(line) {
            //Run
            let tData = {
                cartName: this.cart.cartName,
                cartID: this.cart.cartID,
                lineID: line.lineID,
                line: line
            };
            host.notification.showModal(host.components.getComponent('g-cart-files-upload'), tData, { size: 'default' });
        },
        cmdRenameCart() {
            let tData = {
                callback: () => this.loadData(),
                cartName: this.cart.cartName,
                cartID: this.cart.cartID
            };
            host.notification.showModal(host.components.getComponent('g-cart-create-dialog'), tData, { size: 'default' });
        },
        cmdRemoveMessage(message) {
            // #region Api
            host.api.delete(`commerce/checkout/${this.cart.cartID}/messages/${message.id}`);
            // #endregion
            // #region Remove
            this.messages.splice(this.messages.indexOf(message));
            // #endregion
        },
        // #endregion
        // #region Helper
        getFontStyle(item) {
            //new
            let tItem = {};
            //Bold
            if (item.fontBold) {
                tItem['font-weight'] = 'bold';
            }
            //Color
            if (item.fontColor) {
                tItem['color'] = item.fontColor;
            }
            return tItem;
        },
        // #endregion
    },
    // #endregion
});
// #endregion
